module.exports = __webpack_public_path__ + "static/img/jubilee_emblem_ic_2024.858b9c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/jubilee_emblem_ic_2024.png
// module id = 81
// module chunks = 1